export default "__VITE_ASSET__oiLFH7e9__"